import { FC, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import _ from 'lodash'
import { ExpiredResponseType } from '../../../services/um/useSearchExpired'
import { setPrefixName } from '../../../utilities/prefixName'
import { convertDateToFormatTH, convertDateToFormatEN } from '../../../utilities/date'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import CustomPagination from '../../report/closed/CustomPagination'
import CustomNoRowsOverlay from '../../report/closed/CustomNoRowsOverlay'
import { CustomSortingASCcending, CustomSortingDescending } from '../../report/closed/CusromSorting'
interface DataTableProps {
    data: ExpiredResponseType[]
}

type ExpiredDataRowType = {
    id: number
    projectNumber: string
    expiredDate: string
    name: string
    researcherName: string
    projectType: string
    projectName_TH: string
    projectName_EN: string
}

const DataTable: FC<DataTableProps> = ({ data }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const [dataList, setDataList] = useState<ExpiredDataRowType[]>([])

    useEffect(() => {
        setDataFormat()
    }, [data, lang])

    const convertDate = (date: string | null) => {
        if (lang === 'th' && date) {
            return convertDateToFormatTH(date)
        } else if (lang === 'en' && date) {
            return convertDateToFormatEN(date)
        } else {
            return '-'
        }
    }

    const setDataFormat = () => {
        let convertData: ExpiredDataRowType[] = data.map((itm) => {
            return {
                id: itm.projectID,
                projectNumber: itm.projectNumber ?? '-',
                expiredDate: convertDate(itm.expiredDate) ?? '-',
                name: setPrefixName(itm)[lang] ?? '-',
                researcherName: itm.researcherTypeName[lang] ?? '-',
                projectType: itm.projectType.name[lang] ?? '-',
                projectName_TH: itm.projectName.th ?? '-',
                projectName_EN: itm.projectName.en ?? '-',
            }
        })

        setDataList(convertData)
    }

    const column: GridColDef[] = [
        {
            field: 'projectNumber',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN1'),
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'expiredDate',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN2'),
            width: 180,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'name',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN3'),
            width: 300,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'researcherName',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN4'),
            type: 'string',
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectType',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN5'),
            type: 'string',
            width: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectName_TH',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN6'),
            type: 'string',
            width: 300,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'projectName_EN',
            headerName: translate.get('UM.EXPIRED.DATA_TABLE.COLUMN7'),
            type: 'string',
            width: 400,
            headerClassName: 'super-app-theme--header',
        },
    ]

    return (
        <div style={{ width: '100%', marginTop: 16 }}>
            <DataGrid
                className={classes.root}
                rows={dataList}
                columns={column}
                ///pagination
                autoHeight={true}
                pagination
                pageSize={10}
                rowsPerPageOptions={[10]}
                sortingOrder={['asc', 'desc']}
                disableColumnMenu={true}
                disableSelectionOnClick={true}
                components={{
                    Pagination: CustomPagination,
                    NoRowsOverlay: CustomNoRowsOverlay,
                    // ColumnSortedDescendingIcon: CustomSortingDescending,
                    // ColumnSortedAscendingIcon: CustomSortingASCcending,
                }}
            />
        </div>
    )
}
const useStyles = makeStyles((theme) => ({
    root: {
        '& .super-app-theme--header': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
        '& .MuiDataGrid-columnSeparator': {
            visibility: 'hidden',
        },

        '& .header-table': {
            backgroundColor: '#DB5F8E',
            color: '#FFFFFF',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-sortIcon': {
            color: '#FFFFFF',
        },
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            display: 'none',
        },
        '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        width: '100%',
        marginTop: 16,
    },
}))

export default DataTable
